<template>
  <div id="covid-launcher-module" @click="consult()">
    <div id="module-header">
      <app-icon
        name="coronavirus"
        size="small"/>
      <span>Covid-19 &#8226; {{ contents.CovidModule ? contents.CovidModule.department : 'Informations' }}</span>
    </div>
    <template v-if="!contents.CovidModule || contents.CovidModule.infos.length === 1">
      <div id="alt">{{ contents.CovidModule ? contents.CovidModule.infos[0].message : 'Chargement en cours' }}</div>
    </template>
    <template v-else>
      <div id="data-template">
        <div class="data">
          <div class="infos" :class="contents.CovidModule.status.h">
            <span class="data-value">{{ contents.CovidModule.infos[1].hospitalises }}</span>
            <app-icon
              :name="contents.CovidModule.status.h"
              size="micro"/>
          </div>
          <span class="data-title">Hospitalisations</span>
        </div>
        <div class="data">
          <div
            class="infos" :class="contents.CovidModule.status.r">
            <span class="data-value">{{ contents.CovidModule.infos[1].reanimation }}</span>
            <app-icon
              :name="contents.CovidModule.status.r"
              size="micro"/>
          </div>
          <span class="data-title">Réanimations</span>
        </div>
        <div class="data">
          <div
            class="infos">
            <span class="data-value">{{ contents.CovidModule.infos[1].gueris - contents.CovidModule.infos[0].gueris }}</span>
          </div>
          <span class="data-title">Guérisons</span>
        </div>
      </div>
      <span id="data-source">Données du {{ new Date(contents.CovidModule.infos[1].date) | formatDate }} (Santé Publique France)</span>
    </template>
  </div>
</template>

<style lang="sass">
#covid-launcher-module
  border-top: 2.5px solid #b0bec5
  position: relative
#alt
  align-items: center
  bottom: 1.5rem
  display: flex
  justify-content: center
  font-family: 'RobotoThinItalic'
  font-size: .7em
  position: absolute
  text-align: center
  width: 100%
#module-header
  align-items: center
  display: flex
  height: 5rem
  margin-bottom: .45rem
  svg
    color: #009A02
    margin: 0 .7rem
  span
    font-family: 'RobotoLight'
    font-size: .8em
.error-template
    align-items: center
    display: flex
    justify-content: center
    margin-top: 2rem
#loading-template
  align-items: center
  display: flex
  flex-direction: column
  span
    color: #9e9e9e
    font-family: 'RobotoLightItalic'
    font-size: .8em
    margin-top: 2rem
#covid-error-template
  align-items: center
  display: flex
  flex-direction: column
  justify-content: center
  span
    color: #9e9e9e
    font-family: 'RobotoLight'
    font-size: .8em
#data-template
  display: flex
.data
  display: flex
  flex-direction: column
  margin: 0 1rem
  .infos
    align-items: center
    display: flex
    .data-value
      font-family: 'RobotoRegular'
      font-size: .85em
      margin-right: .6rem
    &.south
      svg
        color: #1b5e20
    &.north
      svg
        color: #b71c1c
    &.unfold_less
      svg
        color: #263238
  .data-title
    font-family: 'RobotoLight'
    font-size: .6em
#data-source
  bottom: .5rem
  font-family: 'RobotoThinItalic'
  font-size: .45em
  position: absolute
  right: .5rem
</style>

<script>
import AppIcon from '@/components/icons/AppIcon.vue';

export default {
  name: 'CovidModule',

  components: {
    AppIcon,
  },

  props: {
    config: Object,
    clock: Date,
    entranceConfig: Object,
    contents: Object,
  },

  methods: {
    consult() {
      if (this.contents.CovidModule.infos.length > 1) {
        this.$router.push({ name: 'covidPage' });
      }
    },
  },

  filters: {
    formatDate(value) {
      const d = new Date(value);
      const options = { day: 'numeric', year: 'numeric', month: 'numeric' };
      return value ? new Intl.DateTimeFormat('fr-FR', options).format(d) : '';
    },
  },
};
</script>
